import {createTheme} from "@mui/material";
import baseTheme from "./baseTheme";

export const lightTheme = createTheme(baseTheme, {
  palette: {
    mode: "light",
    colors: {
      primary: "#10458c",
      secondary: "#C00B6C",
      white: "#FFFFFF",
      background: "#FFFFFF"
    },
    text: {
      primary: "#1E1E1E",
      secondary: "#646464",
      title: "#10458c",
      divider: "#E0E0E0"
    },
    sidebar: {
      background: "#ECF0FB",
      border: "#e0e0e0",
      title: "#10458c",
      itemText: "#56697C",
      itemHoverBg: "#FFFFFF",
      itemHoverText: "#10458c"
    },
    windowScreen: {
      background: "#FAFBFF",
      headerBackground: "#FFFFFF",
      title: "#10458c"
    },
    card: {
      background: "#FFFFFF",
      border: "#ebeaeb",
      borderRadius: "12px",
      borderShadow: "3px 3px 10px rgba(20, 43, 69, 0.1)"
    },
    listView: {
      headerBackground: "#ECF0FB",
      headerText: "#56697C",
      rowHoverBackground: "#FAFBFF"
    },
    components: {
      SnackbarContent: {
        styleOverrides: {
          root: {
            "&.notistack-MuiContent-copy": {
              backgroundColor: "#d4edda !important",
              color: "#155724 !important",
              border: "1px solid #c3e6cb !important",
              borderRadius: "4px !important"
            }
          }
        }
      }
    }
  }
});

export const darkTheme = createTheme(baseTheme, {
  palette: {
    mode: "dark",
    colors: {
      primary: "#10458c",
      secondary: "#C00B6C",
      background: "#2c2c2c"
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#CCCCCC",
      title: "#CCCCCC",
      divider: "#444444"
    },
    sidebar: {
      background: "#191919",
      border: "#0d0d0d",
      title: "#70BFEC",
      itemText: "#FFFFFF",
      itemHoverBg: "#252525",
      itemHoverText: "#70BFEC"
    },
    windowScreen: {
      background: "#1d1d1d",
      headerBackground: "#0d0d0d",
      title: "#FFFFFF"
    },
    card: {
      background: "#252525",
      border: "#171717",
      borderRadius: "12px",
      borderShadow: "3px 3px 10px rgba(20, 43, 69, 0.1)"
    },
    listView: {
      headerBackground: "#2f2f2f",
      headerText: "#CCCCCC",
      rowHoverBackground: "#333333"
    },
    components: {
      SnackbarContent: {
        styleOverrides: {
          root: {
            "&.notistack-MuiContent-copy": {
              backgroundColor: "#d4edda !important",
              color: "#155724 !important",
              border: "1px solid #c3e6cb !important",
              borderRadius: "4px !important"
            }
          }
        }
      }
    }
  }
});
